import '.i1{border-bottom:1px solid var(--brand-secondary);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.i2{padding:1.5rem 0;}.ssr-plugin'
import '.au{border:none;}.ssr-plugin'
import '.cs{background:transparent;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.gz{text-align:left;}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.f1{width:1.5rem;}.ssr-plugin'
import '.i3{font-size:1.25rem;}.ssr-plugin'
import '.cl{font-weight:700;}.ssr-plugin'
import '.i4{padding-bottom:1.125rem;}.ssr-plugin'
import { useId, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { type Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'

export type FaqItemProps = {
  question: string
  answer: string
  style?: Style
}

export const FaqItem = ({ question, answer, style }: FaqItemProps) => {
  const baseId = useId()
  const panelId = `${baseId}-panel`
  const triggerId = `${baseId}-trigger`
  const [open, setOpen] = useState(false)

  return (
    <styled.div className="i1"
      style={{
        ...style,
      }}
    >
      <button className="d n i2 au cs a1 gz"
        type="button"
        id={triggerId}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <Title.H3
          style={{
            flex: 1,
            margin: 0,
          }}
        >
          {question}
        </Title.H3>
        <span className="ar d t at f1 i3 cl"
          aria-hidden
        >
          <FontAwesomeIcon icon={open ? faMinus : faPlus} />
        </span>
      </button>
      {open ? (
        <div className="i4"
          id={panelId}
          role="region"
          aria-labelledby={triggerId}
        >
          <Text.Medium
            style={{
              margin: 0,
              color: 'var(--brand-secondary)',
              opacity: 0.85,
              lineHeight: '1.45',
              fontWeight: 400,
            }}
          >
            {answer}
          </Text.Medium>
        </div>
      ) : null}
    </styled.div>
  )
}
